import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CloseIcon from '../../SVG/CloseIcon';
import RedIconSVG from '../../SVG/RedIconSVG';

const TemplateDeleteConfirm = ({ show, onClose, onConfirm, templateName }) => {
  return (
    <Modal
      className="modal-delete"
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Body>
        <CloseIcon handleModalClose={onClose} />
        <RedIconSVG />

        <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
          Delete Message Template
        </Modal.Title>
        <p>
          Are you sure you want to delete <strong>{templateName}</strong>?
          <br />
          This action cannot be undone.
        </p>
        <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
          <Button
            variant="outline-secondary"
            onClick={onClose}
            style={{ minWidth: 160 }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            style={{ minWidth: 160 }}
          >
            Confirm
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TemplateDeleteConfirm;
